import { getSubmittedDetails } from '../../cred';

export const initialSubmittedDetails = {
	panCard: false,
	eyeFront: false,
	eyeBack: false,
	email: undefined,
	phone: undefined,
	'2fa_en': '',
	pan: undefined,
	dob: '-',
	name: undefined,
	aadhar: undefined,
	allBanks: [],
	mobile_bank: undefined,
	ifsc: undefined,
	branch: undefined,
	acc_type: undefined,
	name_bank: undefined,
	acc_num: undefined,
	rating: undefined,
};

export const getDetails = async () => {
	const { status, data } = await getSubmittedDetails();
	if (status === 1) {
		// if (checkDocument()) {
		// 	window.fcWidget.user.setFirstName(data.name);
		// 	window.fcWidget.user.setEmail(data.email);
		// 	window.fcWidget.user.setPhone(data.phone);
		// 	if (!window.fcWidget.isInitialized()) {
		// 		window.fcWidget.init({
		// 			token: '5813461b-620f-4870-9473-cdd8db50dd1d',
		// 			host: 'https://wchat.freshchat.com',
		// 		});
		// 	}
		// }
		return {
			submittedDetails: Object.assign({}, initialSubmittedDetails, data),
		};
	}
	return {};
};
